import _ from 'lodash';
import BaseForm from '../base';
import { EventSelect, EquipmentSelect, OrganizationSelect, eventType, enabled, EventCondition, supportedEventConditions, EquipmentType } from './form-parts';
import { COL_6, COL_12 } from './form-parts/columns';
export default class NotifyEmail extends BaseForm {
    static nonStatic = true;
    constructor(...args) {
        super(...args);
    }
    async load() {
        const [orgSelector, eventFromEquipmentSelector, equipmentTypeSelector, eventSelector, eventCondition,] = await Promise.all([
            OrganizationSelect.load(),
            new EquipmentSelect().load({
                customKey: 'eventFromEquipment',
                customDescription: 'Equipment that is triggering event. List filtered by Organization.',
                eqTriggerSelectMode: true,
                filterOnProperty: 'organizationSelect',
            }),
            EquipmentType.load({
                hideOn: 'eventFromEquipment'
            }),
            EventSelect.load({
                evTriggerSelectMode: true,
                filterOnProperty1: 'eventFromEquipment',
                filterOnProperty2: 'equipmentTypeSelect'
            }),
            EventCondition.load('event', 'pattern'),
        ]);
        this.components = [
            {
                key: 'general',
                label: 'general',
                title: 'General',
                type: 'panel',
                components: [
                    {
                        label: 'Columns',
                        columns: [
                            {
                                ...COL_12,
                                components: [orgSelector],
                            },
                            {
                                ...COL_6,
                                components: [{
                                        label: 'Name',
                                        key: 'name',
                                        type: 'textfield',
                                        validate: {
                                            required: true
                                        },
                                    }],
                            },
                            {
                                ...COL_6,
                                components: [{
                                        label: 'Description',
                                        key: 'description',
                                        type: 'textfield',
                                    }],
                            },
                            {
                                ...COL_6,
                                components: [enabled],
                            },
                        ],
                        key: 'columns',
                        type: 'columns',
                        input: false,
                        tableView: false
                    }
                ]
            },
            {
                key: 'criteria',
                label: 'criteria',
                title: 'Criteria',
                type: 'panel',
                components: [
                    {
                        label: 'Columns',
                        columns: [
                            {
                                ...COL_12,
                                components: [eventFromEquipmentSelector],
                            },
                            {
                                ...COL_12,
                                components: [equipmentTypeSelector],
                            },
                            {
                                ...COL_12,
                                components: [eventSelector],
                            },
                            {
                                ...COL_12,
                                components: [eventType],
                            },
                        ],
                        key: 'columns',
                        type: 'columns',
                        input: false,
                        tableView: false
                    }
                ]
            },
            {
                key: 'condition',
                label: 'condition',
                title: 'Event Condition',
                type: 'panel',
                components: [{
                        ...COL_6,
                        components: [eventCondition],
                    }],
                hidden: true,
                customConditional: ({ data }) => {
                    const filterPropertyValue = _.get(data, ['event', 'pattern']);
                    return Boolean(supportedEventConditions[filterPropertyValue]?.eventData);
                },
            },
            {
                key: 'parameters',
                label: 'parameters',
                title: 'Parameters',
                type: 'panel',
                components: [{
                        label: 'Columns',
                        columns: [
                            {
                                ...COL_6,
                                components: [{
                                        label: 'Addressee',
                                        key: 'addressee',
                                        description: 'Name of the recipient',
                                        type: 'textfield',
                                        validate: {
                                            required: true
                                        },
                                    }],
                            },
                            {
                                ...COL_6,
                                components: [{
                                        label: 'Template',
                                        key: 'template',
                                        type: 'select',
                                        multi: false,
                                        defaultValue: 'event',
                                        validate: {
                                            required: true
                                        },
                                        data: {
                                            values: [{
                                                    label: 'Event',
                                                    value: 'event'
                                                }
                                            ]
                                        }
                                    }],
                            }
                        ],
                        key: 'columns',
                        type: 'columns',
                        input: false,
                        tableView: false
                    }],
                input: false,
                tableView: false
            },
            {
                key: 'email',
                label: 'email',
                title: 'Email',
                type: 'panel',
                components: [{
                        label: 'Columns',
                        columns: [
                            {
                                ...COL_6,
                                components: [{
                                        label: 'To',
                                        key: 'to',
                                        description: 'email address',
                                        type: 'textfield',
                                        validate: {
                                            required: true
                                        },
                                    }],
                            },
                            {
                                ...COL_6,
                                components: [{
                                        label: 'Subject',
                                        key: 'subject',
                                        description: 'email subject',
                                        type: 'textfield',
                                        validate: {
                                            required: true
                                        },
                                    }],
                            },
                            {
                                ...COL_12,
                                components: [{
                                        label: 'Body',
                                        key: 'body',
                                        description: 'email message',
                                        type: 'textarea',
                                        validate: {
                                            required: true
                                        },
                                    }],
                            }
                        ],
                        key: 'columns',
                        type: 'columns',
                        input: false,
                        tableView: false
                    }],
                input: false,
                tableView: false
            },
        ];
    }
    static getModelStructure() {
        return {
            name: ['name'],
            description: ['description'],
            organizationSelect: ['type', 'parameters', 'org'],
            enabled: ['enabled'],
            eventFromEquipment: ['criteria', 'trigger.body.data.equipment'],
            equipmentTypeSelect: {
                doNotSave: true,
                dataType: 'custom',
                path: ['criteria', 'trigger.body.data.eventName', 'pattern'],
                func: (value) => value.split('/')[0]
            },
            event: ['criteria', 'trigger.body.data.eventName'],
            eventType: ['criteria', 'trigger.body.event'],
            eventCondition: {
                dataType: 'grid',
                basePath: 'criteria'
            },
            addressee: ['action', 'parameters', 'addressee'],
            template: ['action', 'parameters', 'template'],
            to: ['action', 'parameters', 'to'],
            subject: ['action', 'parameters', 'subject'],
            body: ['action', 'parameters', 'body'],
        };
    }
}
